export enum OrderLimit {
  E_TRANSFER_MINIMUM_LIMIT = 1,
  E_TRANSFER_PURCHASE_LIMIT = 25000,
  E_TRANSFER_REDEEM_LIMIT = 5000
}
